import React  from "react";
import { useParams } from "react-router-dom";
import { Pendulum } from "../components/componentReference/Pendulum";
import { FooterAndButon } from "../components/componentFooter/Footer";
export function Reference() {
  const params = useParams();
  window.scrollTo(0, 0);
  return (
    <>
      <Pendulum props={params} />
      <FooterAndButon />
    </>
  );
}